module.exports = __webpack_public_path__ + "static/media/apps_flyer.7a6e36bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/roi/apps_flyer.png
// module id = 3309
// module chunks = 0